import React, { useEffect } from "react";
import { Navigate, Outlet, useLocation, useParams } from "react-router-dom";
import i18n from "../i18n";
import {
  getPreferredLanguage,
  isSupportedLanguage,
  normalizeLanguage,
} from "../utils/languageRouting";

/**
 * Validates /:lang, syncs i18n with the URL, and renders nested public routes.
 * Invalid first segments (e.g. /about) redirect to /{preferred}/about.
 */
const LanguageLayout = () => {
  const { lang } = useParams();
  const location = useLocation();
  const isValid = isSupportedLanguage(lang);

  useEffect(() => {
    if (!isValid) return;
    const next = normalizeLanguage(lang);
    if (normalizeLanguage(i18n.language) !== next) {
      i18n.changeLanguage(next);
    }
  }, [lang, isValid]);

  if (!isValid) {
    const preferred = getPreferredLanguage();
    return (
      <Navigate
        to={`/${preferred}${location.pathname}${location.search}${location.hash}`}
        replace
      />
    );
  }

  return <Outlet />;
};

export default LanguageLayout;
